import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';

export const invitePromptOnLinkInsertExperience = new UFOExperience(
	'invite-prompt-on-link-insert',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.PageLoad,
	},
);
